import * as React from "react";
const SvgFiRrForklift = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-forklift_svg__a)">
      <path
        fill="#062147"
        d="M23 18h-1.5a.5.5 0 0 1-.5-.5v-13a1 1 0 1 0-2 0V13h-3.08l-1.796-8.98A5.014 5.014 0 0 0 9.221 0H5C2.243 0 0 2.243 0 5v15.5C0 22.43 1.57 24 3.5 24S7 22.43 7 20.5V20h3v.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-2a1 1 0 0 0-.02-.196L16.319 15h2.68v2.5c0 1.379 1.122 2.5 2.5 2.5h1.5A1 1 0 0 0 23 18M5 2h4.221a3.01 3.01 0 0 1 2.942 2.412L13.881 13h-3.28c-.496 0-.937-.334-1.07-.812A3.01 3.01 0 0 0 6.642 10H2V5c0-1.654 1.346-3 3-3m0 18.5c0 .827-.673 1.5-1.5 1.5S2 21.327 2 20.5V20h3zm8.5 1.5c-.827 0-1.5-.673-1.5-1.5V20h3v.5c0 .827-.673 1.5-1.5 1.5m1.38-4H2v-6h4.642c.446 0 .842.3.963.729A3.12 3.12 0 0 0 10.601 15h3.68z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-forklift_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrForklift;
